import { Component, Vue } from 'vue-property-decorator';
import gsap from 'gsap';

@Component
export default class QuestionMixins extends Vue {
  // Revert the question option key with a human readable name
  answerText(question: Model) {
    let text = question.value.answer;
    if (!question.value.answer) {
      return;
    }
    switch (question.type) {
      case 'radiobutton':
      case 'checkbox':
      case 'body_parts':
      case 'country':
      case 'state':
      case 'dropdown_single':
      case 'dropdown_multiple': {
        // split the raw answer value by ',', multiple answer example: "a,b,c"
        const selectedOptions = text.split(',');
        if (selectedOptions.length > 0) {
          // selectedOptions is an array, each item in the array is a quesiton option key.
          // we need to revert the option key by the option display name.
          // due to the question has been remap to align the library setup, so the "display_name" has been remapped to "title"
          text = selectedOptions
            .map((optionKey) => {
              // `optionKey` is answered option key
              // `opt['value']` is one of answer option key defined in question
              const answerOption = question.options.find(
                (opt) => opt['value'] === optionKey
              );
              // if answerOption is found, return answer option "display_name" a.k.a. `answerOption["title"]`
              // if answerOption is NOT found, return it original answer option key wrapped with "[]"
              return answerOption ? answerOption['title'] : `[${optionKey}]`;
            })
            .join(', ');
        } else {
          return null;
        }
        break;
      }
      case 'datepicker':
      case 'datetimepicker': {
        if (question.options.range) {
          text = text.split(',');
          const [from, to] = text;
          const fromDate = new Date(from);
          const toDate = new Date(to);
          if (question.options.date_format === 'mm/yy') {
            text = `${(fromDate.getMonth() + 1)
              .toString()
              .padStart(2, '0')}/${fromDate.getFullYear()} - ${(
              toDate.getMonth() + 1
            )
              .toString()
              .padStart(2, '0')}/${toDate.getFullYear()}`;
          } else {
            text = `${fromDate
              .getDate()
              .toString()
              .padStart(2, '0')}/${(fromDate.getMonth() + 1)
              .toString()
              .padStart(2, '0')}/${fromDate.getFullYear()} - ${toDate
              .getDate()
              .toString()
              .padStart(2, '0')}/${(toDate.getMonth() + 1)
              .toString()
              .padStart(2, '0')}/${toDate.getFullYear()}`;
          }
        } else {
          const date = new Date(text);
          if (question.options.date_format === 'mm/yy') {
            text = `${(date.getMonth() + 1)
              .toString()
              .padStart(2, '0')}/${date.getFullYear()}`;
          } else {
            text = `${date
              .getDate()
              .toString()
              .padStart(2, '0')}/${(date.getMonth() + 1)
              .toString()
              .padStart(2, '0')}/${date.getFullYear()}`;
          }

          if (question.type === 'datetimepicker') {
            text =
              `${date
                .getHours()
                .toString()
                .padStart(2, '0')}:${date
                .getMinutes()
                .toString()
                .padStart(2, '0')}` + text;
          }
        }
        break;
      }
      default:
        break;
    }
    return text;
  }

  formatQuestionAnswer(question) {
    const mappedQuestion = this.$store.getters['Questionnaire/mapQuestion'](
      question
    );
    return this.answerText(mappedQuestion);
  }

  jumpTo(index: number) {
    gsap.to(this.$refs.scroller, {
      scrollTo: this.$refs.groups[index],
      duration: 0.5,
    });
  }
}
